var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Eraser"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.84995 19.775L1.44995 16.375L14.9 2.42499L22.45 9.97499L12.9 19.775H4.84995ZM12.1 17.9L19.825 9.94999L14.95 5.07499L4.04995 16.325L5.64995 17.9H12.1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEraser);
export default __webpack_public_path__ + "static/media/icon-eraser.26ebbf0cde0e8c3f1669d70974349f72.svg";
export { ForwardRef as ReactComponent };